import { jsx as _jsx } from "react/jsx-runtime";
import { Spinner } from '../Spinner';
import { RootHydrateFallbackRoot } from './RootHydrateFallback.styled';
const RootHydrateFallback = ({ caption }) => {
    return (_jsx(RootHydrateFallbackRoot, { children: _jsx(Spinner, { caption: caption }) }));
};
export { RootHydrateFallback };
